






import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./myslick.css"
import React from "react";
import Slider from "react-slick";

function PrevArrow(props) {
    const { className, onClick } = props;
    return (<div
        className={`arrow-container left ${className}`}
        onClick={onClick}
        >
            <div className={`arrow prev-arrow`}></div>
        </div>)
}

function NextArrow(props) {
    const { className, onClick } = props;
    return (<div
        className={`arrow-container right ${className}`}
        onClick={onClick}
        >
            <div className={`arrow next-arrow`}></div>
        </div>)
}

export function SimpleSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow/>,
    nextArrow: <NextArrow/>
  }
  return (
    <Slider className="carousel-container" {...settings}>
      <div className="nunisynth-pic _1">
      </div>
      <div className="nunisynth-pic _2">
      </div>
      <div className="nunisynth-pic _3">
      </div>
      <div className="nunisynth-pic _4">
      </div>
      <div className="nunisynth-pic _5">
      </div>
    </Slider>
  )
}